export const locale = {
  lang: 'es',
  data: {
    'EMAIL_HISTORY': {
     'TITLE':'Historial correo',
     'INST_GRAL':'Puede revisar y dar seguimiento a la información de los correos enviados a los colaboradores',
     'COMPON_MENU':{
      'CARG_LIST_PRODU': 'Cargando lista de productos',
      'ETI_PRODU_ADQUI': 'Productos adquiridos',
      'TITLE_PROD_CER':'Certificar',
      'CER_V1':'Certificar',
      'CER_V2':'Certificar 2.0',
      'CER_V3':'Certificar 3.0',
      'TITLE_PROD_MEDIR':'Medir',
      'MED_V1':'Medir',
      'MED_V2':'Medir mejorado',
      'MED_V3':'Medir',
      'MED_V4':'Medir',
      'MED_V5':'Medir',
      'MED_V6':'Medir',
      'MED_V7':'Medir',
      'MED_V8':'Medir 3.0',
      'TITLE_PROD_PULSE':'Pulsecheck',
      'PULS_V1':'Pulsecheck',
      'PULS_V3':'Pulsecheck 3.0',
      'TITLE_PROD_FOCU':'Focus area',
      'TITLE_PROD_NORM':'Norma 035',
      'TITLE_PROD_CGO_EXPRES':'CGO Express',
      'Certificar':'Certificar',
      'Medir':'Medir',
      'nom35':'Norma 35',
      'CGOExpress':'CGO Express',
      '2021':'2021',
      '2022':'2022',
      '2023':'2023',
      '2024':'2024',
      '2025':'2025',
      '2026':'2026',
      '2027':'2027',
      '2028':'2028',
      '2029':'2029',
      '2030':'2030',
      '2031':'2031',
      '2032':'2032',
      '2033':'2033',
      '2034':'2034',
      '2035':'2035',
      '2036':'2036',
      '2037':'2037',
      '2038':'2038',
      '2039':'2039',
      '2040':'2040',
     }
    },

  }
};
